var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseS(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Zm3.375-5.625L12 12M8.625 8.625 12 12m0 0 3.375-3.375-6.75 6.75"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseS);
export default __webpack_public_path__ + "static/media/close_s.7ad61bf95106a65cebc7f4dcb2cce697.svg";
export { ForwardRef as ReactComponent };